import {Injectable} from '@angular/core';
import {RequesterService} from '../../../services/requester.service';
import {NavController} from '@ionic/angular';
import {EventsService} from '../../../services/events.service';
import {CoachSessionChatModel} from '../models/session-chat.model';

@Injectable({
    providedIn: 'root'
})
export class VideoChatService {

    constructor(
        private event: EventsService,
        private navCtrl: NavController,
        private requesterService: RequesterService
    ) {
    }

    getCoachSessionChat(session_id: number, offset: number = null, limit: number = null): Promise<CoachSessionChatModel[]> {
        return this.requesterService.get('getCoachSessionChat', {session_id, offset, limit})
            .then(data => {
                return data.result;
            })
            .catch(e => {
                console.log('Error getCoachSessionChat >> ', e);
                return null;
            });
    }

    addCoachSessionChat(session_id: number, message: string): Promise<CoachSessionChatModel> {
        return this.requesterService.post('addCoachSessionChat', {session_id, message})
            .then(data => {
                return data.result;
            })
            .catch(e => {
                console.log('Error addCoachSessionChat >> ', e);
                return null;
            });
    }
}
